import {
  formatDateToMonthDayZeroSuppress,
  formatDateWithTime,
} from '../../../shared/services/formatDate';

export type DeadlineObject = {
  deadline: string;
  deadlineColor: string;
  isToday: boolean;
  todayText: string;
  isHighlight: boolean;
};

const HOURS_IN_DAY = 24;
const HIGHLIGHT_DAYS = 7;

export const convertDeadlineRecruitment = (deadline: Date): DeadlineObject => {
  const now = new Date();
  const diffMs = deadline.getTime() - now.getTime();
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffMinutes = Math.floor(diffMs / (1000 * 60));
  let deadlineColor = '';
  let deadlineText = formatDateToMonthDayZeroSuppress(deadline.toString());
  let isToday = false;
  let isHighlight = false;
  let todayText = '';

  if (diffHours <= HOURS_IN_DAY && diffHours >= 0) {
    deadlineText = `${formatDateWithTime(deadline.toString())}`;
    deadlineColor = 'text-notification font-bold';
    isToday = true;
    if (diffHours > 0) {
      todayText = `残り${diffHours}時間`;
    } else if (diffMinutes > 0) {
      todayText = `残り${diffMinutes}分`;
    }
  } else if (diffHours < HOURS_IN_DAY * HIGHLIGHT_DAYS) {
    // 168 hours = 7 days
    deadlineText = `${deadlineText}`;
    deadlineColor = 'text-notification font-bold';
    isHighlight = true;
  }

  return {
    deadline: deadlineText,
    deadlineColor,
    isToday,
    todayText,
    isHighlight,
  };
};
